import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'MI PLAN DE 7 DÍAS',
  desc: 'Sin abrumarte. Sin perderte. Qué hacer exactamente el día 1, el día 3 y el día 7 para ver los primeros cambios esta misma semana.',
  value: '7,97€'
}, {
  title: 'RABIETAS EN PÚBLICO',
  desc: 'El kit de bolsillo para las crisis fuera de casa. Protocolo exacto para el supermercado, el colegio o la calle. Control inmediato cuando más lo necesitas.',
  value: '9,97€'
}, {
  title: 'AUTOESTIMA EN 5 MINUTOS',
  desc: 'Rutinas diarias de 5 minutos para reconstruir la confianza de tu hijo desde dentro. Porque sin autoestima, ninguna técnica funciona del todo.',
  value: '7,97€'
}];
export function Bonuses() {
  return <section className="bg-surface-gray py-12 px-6" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <div className="text-center mb-8" data-id="element-24">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-2" data-id="element-25">
            🎁 3 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-26">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-md border-t-4 border-gold relative overflow-hidden" data-id="element-27">
              <div className="absolute top-4 right-4 bg-navy text-gold text-xs font-bold px-3 py-1 rounded-full" data-id="element-28">
                BONO {i + 1}
              </div>
              <h3 className="font-display text-xl font-bold text-primary mb-2 pr-16 mt-2" data-id="element-29">
                {bonus.title}
              </h3>
              <p className="text-secondary mb-4 flex-grow" data-id="element-30">{bonus.desc}</p>
              <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-31">
                <span className="text-secondary" data-id="element-32">
                  Valor: <span className="line-through" data-id="element-33">{bonus.value}</span>
                </span>
                <span className="text-success font-bold text-lg" data-id="element-34">→ GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy text-white text-center p-6 rounded-xl max-w-2xl mx-auto shadow-lg" data-id="element-35">
          <p className="text-xl md:text-2xl font-bold" data-id="element-36">
            Valor total bonos:{' '}
            <span className="line-through text-gray-400" data-id="element-37">25,91€</span>{' '}
            <span className="text-gold" data-id="element-38">→ GRATIS con tu MegaPack</span>
          </p>
        </motion.div>
      </div>
    </section>;
}